export default function DesertRailsIcon() {
  return (
    <svg viewBox="0 0 64 64" aria-hidden="true">
      <rect width="64" height="64" rx="10" fill="#FFB86A" />
      <circle cx="13" cy="15" r="8" fill="#FFF0A0" />
      <path d="M0 40l10-8h12l6 5 8-9h10l8 8 10-3v31H0Z" fill="#D9824E" />
      <rect x="0" y="50" width="64" height="14" fill="#E8B87C" />
      <rect x="0" y="52" width="64" height="2" fill="#7A5634" />
      <path d="M8 34v-6h4v6M10 28v-4" stroke="#3E8D45" strokeWidth="3" strokeLinecap="round" />
      <rect x="18" y="38" width="22" height="10" rx="5" fill="#2F6F5E" />
      <rect x="36" y="31" width="13" height="17" rx="1.5" fill="#C0392B" />
      <rect x="34" y="29" width="17" height="3" rx="1" fill="#6A2318" />
      <rect x="39" y="34" width="7" height="5" rx="1" fill="#BFE8FF" />
      <path d="M21 38v-6h-2l1-4h6l1 4h-2v6Z" fill="#1E1E24" />
      <path d="M14 48l4-8v8Z" fill="#C0392B" />
      <circle cx="24" cy="49" r="3.5" fill="#C0392B" stroke="#2A2A30" strokeWidth="1.5" />
      <circle cx="33" cy="49" r="3.5" fill="#C0392B" stroke="#2A2A30" strokeWidth="1.5" />
      <circle cx="43" cy="49" r="3" fill="#C0392B" stroke="#2A2A30" strokeWidth="1.5" />
      <circle cx="24" cy="22" r="4" fill="#F4F0EC" />
      <circle cx="31" cy="17" r="3.2" fill="#F4F0EC" opacity="0.85" />
      <circle cx="38" cy="13" r="2.4" fill="#F4F0EC" opacity="0.65" />
      <rect x="18" y="40" width="4" height="3" rx="1" fill="#FFF3B0" />
    </svg>
  );
}
